module.exports = __webpack_public_path__ + "static/media/waitmist.7aa48236.gif";